import { WarningCircle, X } from "@phosphor-icons/react";
import { useTranslation } from '@client-app/i18n';
import React from "react";

export interface RepeatedStoreNoticeContent {
  title: string;
  description: string;
}

interface RepeatedStoreNoticeProps {
  content: RepeatedStoreNoticeContent;
  onDismiss: () => void;
}

const RepeatedStoreNotice: React.FC<RepeatedStoreNoticeProps> = ({
  content,
  onDismiss,
}) => {
  const { t } = useTranslation();

  return (
  <div className="fixed right-6 top-6 z-[10050] w-full max-w-[420px] pointer-events-none">
    <div className="pointer-events-auto relative overflow-hidden rounded-[28px] border border-gray-100 border-l-4 border-l-amber-500 bg-white px-5 py-4 text-left shadow-[0_18px_44px_rgba(26,22,47,0.14)] transition-all duration-200 animate-in slide-in-from-right-full fade-in">
      <div className="pr-8">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 shrink-0 text-amber-600">
            <WarningCircle size={20} weight="fill" />
          </div>
          <div>
            <div className="text-[15px] font-semibold tracking-tight text-[#1A162F]">
              {content.title}
            </div>
            <div className="mt-1 text-sm leading-relaxed text-[#667085]">
              {content.description}
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        aria-label={t('website.onboarding.notice.dismiss')}
        onClick={onDismiss}
        className="absolute right-4 top-4 rounded-full p-1 text-[#A0A7B8] transition-colors hover:bg-[#F5F7FB] hover:text-[#667085]"
      >
        <X size={16} />
      </button>
    </div>
  </div>
  );
};

export default RepeatedStoreNotice;
